(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name smb-app.smbContentTypesConfig
	 * @module smb-app
	 * @restrict E
	 *
	 * @description
	 * Displays the configuration section for a list of content types that belong
	 * to a specific content type group.
	 *
	 * @usage
	 *
	 * <smb-content-types-config content-type-group-id="11" />
	 *
	 * @element input
	 * @param {number=} contentTypeGroupId The id of the content type group whose content types are being displayed.
	 */

	angular.module('smb-app')
		.directive('smbContentTypesSearch', ContentTypesSearchDirective)
		.controller('ContentTypesSearchController',
		[
			'gettextCatalog',
			'smbToolbarService',
			'smbContentTypesSearchDataStore',
			'smbIconTypes',
			ContentTypesSearchController
		]);

	var templateUrl = require('./contentTypesSearch.template');
	function ContentTypesSearchDirective() {
		return {
			restrict: 'E',
			controller: ContentTypesSearchController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				groupId: '@'
			}
		};
	}

	function ContentTypesSearchController(gettextCatalog, smbToolbarService, smbContentTypesSearchDataStore, smbIconTypes) {
		var vm = this;
		vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];

		// TODO: Add group name?
		smbToolbarService.set(gettextCatalog.getString('Search Document Types'), 'search.contentTypeGroups');
		smbToolbarService.backArrowStateParams = undefined;

		vm.contentTypesSearchDS = smbContentTypesSearchDataStore;

		// TODO: Error handling
		smbContentTypesSearchDataStore.getContentTypes(vm.groupId);
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/contentTypesSearch/contentTypesSearch.js
// module id = 77
// module chunks = 1